'use client';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';

interface BaseDatePickerProps extends DatePickerProps<Dayjs> {
  label?: string;
  slotProps?: any;
}

export function BaseDatePicker({ label, slotProps, ...otherProps }: BaseDatePickerProps) {
  return <DatePicker {...otherProps} label={label} slotProps={slotProps} />;
}
